<template>
    <section class="xnax-login">
        <div class="login-rubies">
            <p class="login-intro">{{tPinMessage}}</p>
            <div class="login-form">
                <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/rubies-logo.png" alt="">

                <div v-if="alert.show" class="alert-box">
                    <div class="row">
                        <div class="col-sm-12">
                            <ui-alert @dismiss="alert.show = false" :type="alert.type" v-show="alert.show">
                                {{alert.message}}
                            </ui-alert>
                        </div>
                    </div>
                </div>

                <div v-if="PasswordResetStage === 0">
                    <form @submit.prevent="initiatePasswordReset">
                        <div class="row">
                            <div class="col-md-12 form-group mb-1">
                                <label for="username" class="form-label">Username</label>
                                <input
                                        type="text" class="form-input form-control" id="username" name="username"
                                        placeholder="Username" v-model="username" v-validate="'required|alpha_num'" data-vv-name="username"
                                        :class="{'is-danger': errors.has('username') }" required
                                >
                                <span v-show="errors.has('username')" class="error-span is-danger">{{ errors.first('username') }}</span>
                            </div>

                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary btn-xnax-login ">Reset</button>
                            </div>

                            <div class="alter-links">
                                <!--<a href="#">Forgot Password?</a>-->
                                <a @click="updateCurrentComponent('login')" class="mb-2">Login</a>
                                <a  @click="updateCurrentComponent('enroll')">Create Account</a>
                            </div>

                        </div>
                    </form>
                </div>
                <div v-if="PasswordResetStage === 1">
                    <div class="row">
                        <div class="col-sm-12">
                            <div v-if="confirmTransactionPin">
                                <!--input confirmpasscode-->
                                <div class="setPinBox">
                                    <div class="pinHolder">
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 0}"></span>
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 1}"></span>
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 2}"></span>
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 3}"></span>
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 4}"></span>
                                        <span class="pinIndex" :class="{'active': confirmpasscode.length > 5}"></span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <!--input passcode-->
                                <div class="setPinBox">
                                    <div class="pinHolder">
                                        <span class="pinIndex" :class="{'active': passcode.length > 0}"></span>
                                        <span class="pinIndex" :class="{'active': passcode.length > 1}"></span>
                                        <span class="pinIndex" :class="{'active': passcode.length > 2}"></span>
                                        <span class="pinIndex" :class="{'active': passcode.length > 3}"></span>
                                        <span class="pinIndex" :class="{'active': passcode.length > 4}"></span>
                                        <span class="pinIndex" :class="{'active': passcode.length > 5}"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="num-pad alt">
                                <div class="key-pad">
                                    <div class="key-row">
                                        <div class="key-stroke" @click="tPinInputNo(1)">1</div>
                                        <div class="key-stroke" @click="tPinInputNo(2)">2</div>
                                        <div class="key-stroke" @click="tPinInputNo(3)">3</div>
                                    </div>

                                    <div class="key-row">
                                        <div class="key-stroke" @click="tPinInputNo(4)">4</div>
                                        <div class="key-stroke" @click="tPinInputNo(5)">5</div>
                                        <div class="key-stroke" @click="tPinInputNo(6)">6</div>
                                    </div>

                                    <div class="key-row">
                                        <div class="key-stroke" @click="tPinInputNo(7)">7</div>
                                        <div class="key-stroke" @click="tPinInputNo(8)">8</div>
                                        <div class="key-stroke" @click="tPinInputNo(9)">9</div>
                                    </div>

                                    <div class="key-row">
                                        <div class="key-stroke" @click="clear()">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.4 487.4">
                                                <path d="M438.7 179.1c-3.8 3.6-7.5 7.2-11.1 10.9 -6.2-33.6-19.8-65.6-44.5-94.3 -66.7-77.4-187.1-108.5-275-49.5C30.2 98.6-12.7 197.8 3.4 288.9 21.2 390.4 104.4 484.2 220.3 470.5c63.1-7.4 119.9-38.6 159.6-83.7 0.8-0.7 1.5-1.5 2.3-2.3 0.9-1 1.7-2 2.4-3.1 1.6-2.5 2.8-5.3 3.4-8.3l0.5-2.5c2.7-13.8-7.2-27.7-21.7-30.5 -8.5-1.6-16.9 0.9-23 6.1 -2.4 2-4.4 4.5-5.9 7.3 -0.3 0.6-0.8 1.2-1 1.9 -0.1-0.1-0.3-0.1-0.4-0.2 -39.2 45-98.6 74.4-160.2 63C74.4 399.2 38 282.1 62.2 197.4 83.2 124.3 152.9 50.5 240.3 68.8c52.1 11 105.6 47.6 125.1 96.5 2 5.1 3.8 10.2 5.3 15.4 -7.1-5.9-14.6-11.5-22.4-16.7 -12.3-8-27.7-9.4-38.2 2.1 -8.7 9.5-9.4 28.5 2.9 36.5 16.4 10.8 30.7 23.1 43.2 37 7.5 8.4 14.4 17.5 20.5 27.2 1.3 2.1 2.7 4.3 4 6.5 6.2 10.7 16.1 13.6 25.2 11.7 7.4-0.1 14.6-2.7 18.9-8.5 3-4 6-7.9 9-11.8 3.3-4.3 6.7-8.5 10.1-12.6 11.1-13.5 22.9-26.5 35.8-38.6C504.5 190.4 463.3 156.1 438.7 179.1z"></path>
                                            </svg>
                                        </div>
                                        <div class="key-stroke" @click="tPinInputNo(0)">0</div>
                                        <div class="key-stroke" @click="backspace()">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path d="M490.7 64H133.1c-7.2 0-13.9 3.6-17.8 9.6L3.5 244.3c-4.6 7.1-4.6 16.3 0 23.4l111.7 170.7c3.9 6 10.7 9.6 17.8 9.6h357.6c11.8 0 21.3-9.6 21.3-21.3V85.3C512 73.6 502.4 64 490.7 64zM469.3 405.3H144.6L46.8 256l97.8-149.3h324.7V405.3z"></path>
                                                <path d="M198.2 356.4c8.3 8.3 21.8 8.3 30.2 0l70.2-70.2 70.2 70.2c8.3 8.3 21.8 8.3 30.2 0s8.3-21.8 0-30.2L328.8 256l70.2-70.2c8.3-8.3 8.3-21.8 0-30.2s-21.8-8.3-30.2 0l-70.2 70.2 -70.2-70.2c-8.3-8.3-21.8-8.3-30.2 0 -8.3 8.3-8.3 21.8 0 30.2L268.5 256l-70.2 70.2C189.9 334.6 189.9 348.1 198.2 356.4z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="PasswordResetStage === 2">
                    <div>
                        <div>
                            <p class="pageHeaderP">
                                We've sent a 4-digit OTP code to your phone and email.
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-md-12 form-group mb-2">
                                <div class="otp">
                                    <div class="otpBox">
                                        <input
                                                title="" v-model="otp[0]" autocomplete="off" name="venus"
                                                type="text" maxlength="1" autofocus :autocomplete="false"
                                                v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                        >
                                        <input
                                                title="" v-model="otp[1]" autocomplete="off" name="venus"
                                                type="text" maxlength="1" autofocus :autocomplete="false"
                                                v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                        >

                                        <span class="midMark">-</span>

                                        <input
                                                title="" v-model="otp[2]" autocomplete="off" name="venus"
                                                type="text" maxlength="1" autofocus :autocomplete="false"
                                                v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                        >
                                        <input
                                                title="" v-model="otp[3]" autocomplete="off" name="venus"
                                                type="text" maxlength="1" autofocus :autocomplete="false"
                                                v-on:keypress="isNumber($event)" v-on:keyup="otpInputHandler($event)"
                                        >
                                    </div>
                                </div>

                                <!--<p class="otp-resend">-->
                                <p class="pageHeaderP text-center">
                                    If you didn't get an OTP dial *7797*12#.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!--UI Modal For Displaying Success Message-->
                    <ui-modal
                            ref="passwordChangeResultModal" transition="scale-up"
                            :removeHeader= "true" size="small" @hide="notificationModalHide"
                            align-top :align-top-margin="200"
                    >
                        <div class="notification-modal sm">
                            <div class="head">
                                <div class="logo-hold">
                                    <div>
                                        <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                    </div>
                                </div>
                            </div>

                            <div class="bottom">
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-2">
                                            <div class="left">
                                                <div class="status-icon">
                                                    <!--<svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">-->
                                                    <!--<path d="M437 75C388.7 26.6 324.4 0 256 0S123.3 26.6 75 75C26.6 123.3 0 187.6 0 256s26.6 132.7 75 181C123.3 485.4 187.6 512 256 512s132.7-26.6 181-75C485.4 388.7 512 324.4 512 256S485.4 123.3 437 75zM256 491.6c-129.9 0-235.6-105.7-235.6-235.6S126.1 20.4 256 20.4 491.6 126.1 491.6 256 385.9 491.6 256 491.6z"></path>-->
                                                    <!--<path d="M401.6 146.1c-13.9-13.9-36.6-13.9-50.5 0L200.9 296.3l-49.2-49.2c-13.9-13.9-36.6-13.9-50.5 0 -13.9 13.9-13.9 36.6 0 50.5l74.5 74.5c6.7 6.7 15.7 10.5 25.2 10.5s18.5-3.7 25.2-10.5l175.4-175.4C415.5 182.7 415.5 160 401.6 146.1zM387.2 182.2L211.7 357.6c-2.9 2.9-6.7 4.5-10.8 4.5s-7.9-1.6-10.8-4.5l-74.5-74.5c-6-6-6-15.7 0-21.6 3-3 6.9-4.5 10.8-4.5 3.9 0 7.8 1.5 10.8 4.5l56.4 56.4c4 4 10.4 4 14.4 0l157.4-157.4c6-6 15.7-6 21.6 0C393.1 166.5 393.1 176.2 387.2 182.2z"></path>-->
                                                    <!--<path d="M462.1 298.1c-5.5-1.4-11 1.9-12.4 7.4C427.2 394.1 347.5 455.9 256 455.9c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2 100.8 0 188.6-68.2 213.5-165.8C470.9 305.1 467.6 299.5 462.1 298.1z"></path>-->
                                                    <!--<path d="M466.1 245.8c-5.6 0-10.2 4.6-10.2 10.2 0 2.9-0.1 5.9-0.2 8.7 -0.2 5.6 4.1 10.4 9.7 10.6 0.2 0 0.3 0 0.4 0 5.4 0 9.9-4.3 10.2-9.8 0.1-3.2 0.2-6.4 0.2-9.6C476.3 250.4 471.7 245.8 466.1 245.8z"></path>-->
                                                    <!--</svg>-->
                                                    <svg class="success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.2 496.2">
                                                        <path d="M496.2 248.1c0-137-111.1-248.1-248.1-248.1C111.1 0 0 111.1 0 248.1c0 137 111.1 248.1 248.1 248.1C385.1 496.2 496.2 385.1 496.2 248.1z"></path>
                                                        <path d="M384.7 165c-5.8-15.1-17.7-12.7-30.6-10.1 -7.7 1.6-42 11.6-96.1 68.8 -22.5 23.7-37.3 42.6-47.1 57 -6-7.3-12.8-15.2-20-22.3 -22.1-22.1-46.7-37.2-47.7-37.9 -10.3-6.3-23.8-3.1-30.2 7.3 -6.3 10.3-3.1 23.8 7.2 30.2 0.2 0.1 21.4 13.2 39.6 31.5 18.6 18.6 35.5 43.8 35.7 44.1 4.1 6.2 11 9.8 18.3 9.8 1.2 0 2.5-0.1 3.8-0.3 8.6-1.5 15.4-7.9 17.5-16.3 0.1-0.2 8.8-24.3 54.7-72.7 37-39.1 61.7-51.5 70.3-54.9 0.1 0 0.1 0 0.3 0 0 0 0.3-0.1 0.8-0.4 1.5-0.6 2.3-0.8 2.3-0.8 -0.4 0.1-0.6 0.1-0.6 0.1l0-0.1c4-1.7 11.4-4.9 11.5-5C385.4 188.2 389 176.2 384.7 165z" fill="#FFF"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-10 pl-2">
                                            <div class="right">
                                                <p>
                                                    Congrats, your Rubies account password has been updated.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-button">
                                    <button @click="closeModal('passwordChangeResultModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                                </div>
                            </div>
                        </div>
                    </ui-modal>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import AppUtils from "../../utils/BaseUtils/AppUtils";
    import StoreUtils from "../../utils/BaseUtils/StoreUtils";


    export default {
        name: "Forgot",
        components: {},
        data () {
            return {
                PasswordResetStage : 0,

                username: '',

                passcode: '',
                confirmpasscode: '',
                tPinMessage: 'Forgot Your Rubies Password?',
                confirmTransactionPin: false,

                otp: [],

                uniqueref: '',

                alert: {
                    show: false,
                    type: 'error',
                    message: 'Something Went Wrong!'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getAppLoading',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateUsername',
                'updateAppLoading',
                'updateDataOnLogin',
            ]),

            showAlert(show, type, message){
                this.alert.show = show;
                this.alert.type = type;
                this.alert.message = message;
            },
            generateUUID () {
                let d = new Date().getTime()
                let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = (d + Math.random() * 16) % 16 | 0
                    d = Math.floor(d / 16)
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
                });
                localStorage.test = uuid;
                return uuid
            },

            initiatePasswordReset(){
                this.$validator.validateAll();
                if (!this.errors.any()) {
                    //startAppLoading
                    this.updateAppLoading(true);

                    let requestid = this.generateUUID();

                    // console.log('requestid ==>>', requestid);

                    //Consume Login API
                    axios({
                        method:'post',
                        url:'/resetpassword',
                        headers:{'Authorization': ''},
                        data:{
                            mobiledeviceid: `${AppUtils.getDeviceId()}/${StoreUtils.rootGetters("getDeviceFingerPrint")}`,
                            username: this.username,
                            requestid: requestid,
                            source: "Web",
                            devicedetails: requestid,
                            currentpassword: '',
                            appversion: "2.0",
                            deviceplatform: "web",
                        }
                    }).then(response => {
                        //start running
                        this.updateAppLoading(false);

                        // console.log('response ==>>', response);


                        //retrieve login Data
                        let responseData = response.data;

                        if (responseData.responsecode === '00'){
                            console.table(responseData);

                            this.tPinMessage = 'Setup your new Rubies password.'

                            this.uniqueref = responseData.uniqueref

                            this.PasswordResetStage =  1;
                        }else {
                            //reset pin input
                            this.username = '';

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    }).catch(error => {
                        //reset pin input
                        this.username = '';

                        // display error notification
                        this.showAlert(true, 'error', 'Unexpected Error Occurred!')
                    })
                }
            },


            tPinInputNo(no){
                if (this.confirmTransactionPin){
                    //    input The incoming number
                    this.confirmpasscode = this.confirmpasscode + no;
                    //    check if confirm passcode length is up to 4 now
                    this.tPinLengthCheck();
                }
                else {
                    //    input The incoming number
                    this.passcode = this.passcode + no;
                    //    check if passcode length is up to 4 now
                    this.tPinLengthCheck();
                }
            },
            backspace() {
                if(this.confirmTransactionPin){
                    this.confirmpasscode = this.confirmpasscode.slice(0, -1);
                }else {
                    this.passcode = this.passcode.slice(0, -1);
                }
            },
            clear() {
                if(this.confirmTransactionPin){
                    this.confirmpasscode = '';
                }else {
                    this.passcode = '';
                }
            },
            tPinLengthCheck(){
                //reset Notification
                this.alert.show = false;
                if (this.confirmTransactionPin){
                    if (this.confirmpasscode.length === 6){
                        if (this.passcode === this.confirmpasscode){
                            // console.log('tPin match');

                            this.tPinMessage = 'OTP'

                            //    switch pages/stages
                            this.PasswordResetStage = 2
                        }
                        else{
                            this.passcode = '';
                            this.confirmpasscode = '';
                            this.confirmTransactionPin  = false;

                            // display error notification
                            this.showAlert(true, 'error', 'Password mismatch. Try again!')
                            this.tPinMessage = 'Setup your new Rubies password.'
                        }
                    }
                }
                else {
                    if (this.passcode.length === 6){
                        this.confirmTransactionPin = true;
                        this.tPinMessage = 'Confirm your new Rubies password.'
                    }
                }
            },


            isNumber (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            maxlenght (e) {
                let target = e.srcElement || e.target;
                let maxLength = parseInt(target.attributes["maxlength"].value, 10);
                let myLength = target.value.length;
                if (myLength >= maxLength) {
                    let next = target;
                    while (next = next.nextElementSibling) {
                        if (next == null)
                            break;
                        if (next.tagName.toLowerCase() === "input") {
                            next.focus();
                            break;
                        }
                    }
                } else if (myLength === 0) {
                    // Move to previous field if empty (user pressed backspace)
                    let previous = target;
                    while (previous = previous.previousElementSibling) {
                        if (previous == null)
                            break;
                        if (previous.tagName.toLowerCase() === "input") {
                            previous.focus();
                            break;
                        }
                    }
                }
            },
            isAllOtpBoxFilled(){
                if (this.otp[0] && this.otp[1] && this.otp[2] && this.otp[3]){
                    //Consume Final Post API
                    this.completePasswordReset();
                }
            },
            otpInputHandler(e){
                this.maxlenght(e);
                this.isAllOtpBoxFilled()
            },

            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },

            completePasswordReset () {
                // this.otpsubmit = true;

                //start running
                this.updateAppLoading(true);

                let otp = this.otp[0]+this.otp[1]+this.otp[2]+this.otp[3];

                // console.log(otp);

                let dataToBeSent = {
                    uniqueref: this.uniqueref,
                    token: otp,
                    password: this.passcode,
                    pin: '',
                    source: "WEB",
                }

                // console.log('Data To Be Sent ===>>', dataToBeSent);

                axios
                    .post('/resetpasswordcomplete', dataToBeSent)
                    .then(response => {
                        //stop running
                        this.updateAppLoading(false)

                        let responseData = response.data;
                        // console.log('Password Reset Complete Response ===>>', responseData);


                        if (responseData.responsecode === '00'){
                            this.alert.show = false;
                            //Show Success Modal and then redirect to the home page / login page
                            this.openModal('passwordChangeResultModal');
                        } else {
                            //reset step 3 fields
                            this.username = '';
                            this.passcode= ''
                            this.confirmpasscode= ''
                            this.tPinMessage= 'Forgot Your Rubies Password?'
                            this.confirmTransactionPin= false
                            this.otp= []
                            this.uniqueref= ''
                            this.PasswordResetStage = 0

                            // display error notification
                            this.showAlert(true, 'error', responseData.responsemessage)
                        }
                    })
                    .catch(error => {
                        //stop running
                        this.updateAppLoading(false)

                        //reset step 3 fields
                        this.username = '';
                        this.passcode= ''
                        this.confirmpasscode= ''
                        this.tPinMessage= 'Forgot Your Rubies Password?'
                        this.confirmTransactionPin= false
                        this.otp= []
                        this.uniqueref= ''
                        this.PasswordResetStage = 0

                        // display error notification
                        this.showAlert(true, 'error', 'Network Error! Try Again.')
                    })
            },

            notificationModalHide(){
                // change the currentComponent in the store to 'dashboard'
                this.updateCurrentComponent('login')
            },
        },
    }
</script>

<style scoped>
    .num-pad.alt{
        width: auto;
        /* margin: 0 auto; */
        text-align: center;
        display: flex;
    }
    .num-pad.alt .key-pad{
        width: auto;
        margin: 0 auto;
        display: block;
    }
    .num-pad.alt .key-pad .key-row{
        padding-right: 0
    }
    .num-pad.alt .key-pad .key-stroke:last-child{
        margin-right: 0;
    }
</style>